import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ToastConfig } from './utils/toast';

import HomePage from './pages/HomePage/HomePage';
import DashboardPage from './pages/dappPages/DashboardPage/DashboardPage';
import PolicyPage from './pages/UtilityPages/Policy/PolicyPage';
import TermsPage from './pages/UtilityPages/Terms/TermsPage';

function App() {
  const [toastPosition, setToastPosition] = useState(ToastConfig.position);

  useEffect(() => {
    const handleResize = () => {
      setToastPosition(window.innerWidth <= 768 ? "top-center" : "top-right");
    };

    window.addEventListener('resize', handleResize);
    handleResize(); 

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
        <ToastContainer 
          {...ToastConfig}
          position={toastPosition}
        />
      </BrowserRouter>
    </React.StrictMode>
  );
}

export default App; 